import { connect } from 'react-redux';

import { isUserLoggedIn } from 'apps/user/helpers';
import { toggleFeedbackPopup } from '../actions/feedbackPopup';

import FeedbackPopup from '../components/FeedbackPopup';

export default connect(
  (state) => ({
    isFeedbackBetaFeatureEnabled: state.user.betaFeatures.includes('RAVEN_FEEDBACK_POPUP'),
    isPopupOpened: state.feedbackPopup.isPopupOpened,
    isUserLoggedIn: isUserLoggedIn(state.user),
  }), {
    toggleFeedbackPopup,
  }
)(FeedbackPopup);
